import PostLoader from "@/ts/base/Components/PostLoader";

class PostLoaderCollection {

	public loaders: PostLoader[] = [];

	constructor(loaders: PostLoader[]= []) {
		this.loaders = loaders;
	}

	add(loader: PostLoader) {
		this.loaders.push(loader);
	}

	getByContainerId(id: string): PostLoader|null {
		let out = null;

		this.loaders.forEach(item => {
			if (item.id === id) {
				out = item;
				return;
			}
		});

		return out;
	}

	getByContainerPostType(postType: string): PostLoader|null {
		let out = null;

		this.loaders.forEach(item => {
			if (item.postType === postType) {
				out = item;
				return;
			}
		});

		return out;
	}
}

export default PostLoaderCollection;
